import { SegmentedControl } from "@mantine/core";
import { useTranslation } from "react-i18next";

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();

  return (
    <SegmentedControl
      size="xs"
      value={i18n.language}
      onChange={(value) => void i18n.changeLanguage(value)}
      data={[
        { label: t("language.de"), value: "de" },
        { label: t("language.en"), value: "en" },
      ]}
    />
  );
}
